export default {"src":"/_next/static/image/src/assets/images/sort.6a20d25f1e1ff9e264728d214bfc4330.svg","height":12,"width":17};